import React from 'react';
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import ProgressCircle from '../component-files/ProgressCircle';

const StatBox = ({ title, subtitle, icon, progress, increase, borderColor, isDotted }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box
            width="100%"
            m="0 15px" // Reduced margin for smaller width
            sx={{
                backgroundColor: colors.primary[400],
                borderRadius: "8px",  // Slightly smaller rounded corners
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",  // Subtle shadow for smaller size
                padding: "10px", // Reduced padding for compactness
                border: `2px ${isDotted ? "dotted" : "solid"} ${borderColor}`,  // Thinner border
            }}
        >
            <Box display="flex" justifyContent="space-between">
                <Box>
                    {icon}
                    <Typography
                        variant="h6"  // Smaller font size for title
                        fontWeight="bold"
                        sx={{ color: colors.grey[100] }}
                    >
                        {title}
                    </Typography>
                </Box>
                {progress !== undefined && (
                    <Box>
                        <ProgressCircle progress={progress} size={40} /> {/* Smaller progress circle */}
                    </Box>
                )}
            </Box>
            <Box display="flex" justifyContent="space-between" mt="5px">
                <Typography variant="subtitle2" sx={{ color: colors.greenAccent[500] }}>
                    {subtitle}
                </Typography>
                {increase && (
                    <Typography
                        variant="subtitle2"
                        fontStyle="italic"
                        sx={{ color: colors.greenAccent[600] }}
                    >
                        {increase}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default StatBox;
